export const aboutInfo = {
  brandStory: '布丁漫画网成立于2018年，由一群热爱漫画的年轻人创立。我们坚信每一部漫画都是一个独立的世界，承载着作者的梦想和读者的期待。六年来，我们始终坚持"正版、精品、无删减"的原则，为国内漫画爱好者打造了一个纯净、高品质的阅读社区。\n\n我们的团队由资深漫画编辑、技术极客和设计达人组成。大家来自五湖四海，因为对漫画的热爱聚在一起。在这里，我们不仅是同事，更像是一起追漫的伙伴——每周新番更新时办公室里的讨论声比开会还热闹！',
  milestones: [
    { year: '2018', event: '布丁漫画网正式上线，首批签约50位原创漫画作者' },
    { year: '2019', event: '平台注册用户突破100万，上线APP客户端' },
    { year: '2020', event: '推出"创作者扶持计划"，签约作者超过300位' },
    { year: '2021', event: '月活跃用户突破500万，累计漫画作品超2000部' },
    { year: '2022', event: '获评"年度最佳漫画阅读平台"，与多家出版社达成合作' },
    { year: '2023', event: '上线下拉式阅读模式，阅读体验全面升级' },
    { year: '2024', event: '注册用户突破2000万，成为国内Top 3漫画平台' },
  ],
  values: [
    { title: '正版授权', description: '所有漫画作品均获得作者或版权方正版授权，保障创作者权益，推动漫画产业健康发展。', icon: 'ri-shield-check-line' },
    { title: '无删减内容', description: '坚持呈现漫画原汁原味的完整内容，拒绝任何形式的删减修改，让读者看到作者最真实的创作。', icon: 'ri-file-copy-line' },
    { title: '流畅阅读', description: '采用先进的下拉式阅读技术和图片加载算法，确保流畅的阅读体验，翻页零等待。', icon: 'ri-speed-up-line' },
    { title: '社区共建', description: '打造活跃的漫友社区，评论、打分、弹幕互动，让读者与创作者零距离交流。', icon: 'ri-group-line' },
  ],
  platformData: [
    { label: '注册用户', value: '2000万+', icon: 'ri-user-line' },
    { label: '签约作者', value: '500+', icon: 'ri-pencil-line' },
    { label: '漫画作品', value: '3000+', icon: 'ri-book-line' },
    { label: '日活用户', value: '200万+', icon: 'ri-flashlight-line' },
  ],
  teamImage: 'https://readdy.ai/api/search-image?query=Creative%20Chinese%20office%20team%20collaboration%2C%20young%20designers%20and%20editors%20working%20around%20large%20desk%20with%20comic%20art%20displayed%20on%20monitors%2C%20modern%20minimalist%20studio%20with%20warm%20lighting%2C%20manga%20posters%20on%20walls%2C%20clean%20bright%20atmosphere%2C%20professional%20photography%20style%2C%20no%20text&width=800&height=500&seq=about-team-v2-01&orientation=landscape',
  officeImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20tech%20company%20office%20interior%2C%20open%20workspace%20with%20comic%20art%20display%20walls%2C%20comfortable%20reading%20corner%20with%20bookshelves%20full%20of%20manga%2C%20bright%20natural%20light%20through%20large%20windows%2C%20creative%20and%20cozy%20atmosphere%2C%20professional%20architectural%20photography%2C%20no%20text&width=800&height=500&seq=about-office-v2-02&orientation=landscape',
  contactInfo: {
    address: '北京市朝阳区望京SOHO T3 12层',
    phone: '400-888-6666',
    email: 'hello@591chaxin.cn',
    businessEmail: 'hello@591chaxin.cn',
    workHours: '周一至周五 9:00 - 18:00',
  },
  businessCooperation: [
    { title: '内容合作', description: '欢迎漫画作者和版权方联系我们，共同打造优质漫画内容生态。', icon: 'ri-file-text-line' },
    { title: '广告投放', description: '精准触达2000万+漫画爱好者，多样化的广告形态满足不同推广需求。', icon: 'ri-advertisement-line' },
    { title: 'IP授权', description: '旗下热门漫画IP开放授权，涵盖影视改编、周边衍生、游戏联动等多领域。', icon: 'ri-brush-line' },
    { title: '媒体合作', description: '期待与各媒体平台建立长期深度合作关系，共同推动国漫发展。', icon: 'ri-share-line' },
  ],
};